import { PhoneModel } from "src/app/models/common/phone-model";
import { RegionModel } from "src/app/models/common/region";
import { UserRole } from "src/app/models/common/user-role";
import { ICompanyModel } from "src/app/models/customer_master_model/company-model";
import { DocumentModel } from "src/app/models/document";

export interface ExternalMyTeamModel {
    id: string;
    user: User;
    company: ExternalMyTeamCompany;
    role: UserRole;
    external_profile_id: string;
    mobile_number: PhoneModel;
    is_active: boolean;
    email: string;
    first_name: string;
    last_name: string;
    phone: PhoneModel;
    company_name: string;
    address: string;
    has_registered: boolean;
    is_otp_verified: boolean;
    approval_status: string;
    country: string;
    state: string;
    rejection_reason: string;
}

export interface ExternalMyTeamCompany {
    group: string;
    name: string;
    legal_name: string;
    trade_name: string;
    state: string;
    address: string;
    master_agreement_no: string;
    master_agreement_valid_till: Date;
}

export interface User {
    email: string;
    username: string;
    first_name: string;
    last_name: string;
    id: string;
    role: string;
    user_status: UserStatus;
    phone: PhoneModel;
    external_profile: ExternalProfile;
    last_login: Date;
    initials: string;
}

export interface ExternalProfile {
    id: string;
    role: UserRole;
    designation: string;
    first_name: string;
    last_name: string;
    email: string;
    branches: any[];
    theme: string;
    created_at: Date;
    updated_at: Date;
    created_by: string;
    updated_by: string;
    is_active: boolean;
    mobile_number: PhoneModel;
    gender: string;
    company: ICompanyModel;
    picture: DocumentModel;
    initials: string;
    default_page: string;
    region: RegionModel;
}

export interface UserStatus {
    id: string;
    is_active: boolean;
    name: string;
    description: string;
    status_type: number;
    dev_name: string;
    color_code: string;
}

export interface ExternalUserError {
    first_name: string[];
    last_name: string[];
    email: string[];
    mobile_number: string[];
    designation: string[];
    role: string[];
    region: string[];
    gender: string[];
}

export class ExternalUserModel {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    mobile_number: PhoneModel | string;
    designation: string;
    role: UserRole | string;
    region: RegionModel | string;
    gender: string;
    is_active: boolean;
    picture: DocumentModel;

    errors: ExternalUserError;

    constructor() {
        this.first_name = null;
        this.last_name = null;
        this.email = null;
        this.mobile_number = null;
        this.designation = null;
        this.role = null;
        this.region = null;
        this.gender = 'Others';
        this.is_active = true;
        this.picture = null;

        this.resetErrors();
    }

    resetErrors() {
        this.errors = {
            first_name: [],
            last_name: [],
            email: [],
            mobile_number: [],
            designation: [],
            role: [],
            region: [],
            gender: [],
        }
    }

    saveExternalUserPayloadToModel(data: ExternalMyTeamModel) {
        this.id = data.user.external_profile.id;
        this.first_name = data.user.external_profile.first_name;
        this.last_name = data.user.external_profile.last_name;
        this.email = data.user.external_profile.email;
        this.mobile_number = data.user.external_profile.mobile_number;
        this.designation = data.user.external_profile.designation;
        this.role = data.user.external_profile.role;
        this.region = data.user.external_profile.region;
        this.gender = data.user.external_profile.gender;
        this.is_active = data.user.external_profile.is_active;
        this.picture = data.user.external_profile.picture;
    }

    getExternalUserSavePayload() {
        return {
            id: this.id,
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            mobile_number: typeof this.mobile_number == 'object' && this.mobile_number != null ? this.mobile_number.as_e164 : this.mobile_number,
            designation: this.designation,
            role: typeof this.role == 'object' && this.role != null ? this.role.id : this.role,
            region: typeof this.region == 'object' && this.region != null ? this.region.id : this.region,
            gender: this.gender,
            is_active: this.is_active,
        }
    }
}